<ng-template #buttons>
    <app-button
        icon="pi-print"
        label="workData.printDialog.buttons.print"
        (clickEvent)="printRecords()"
    ></app-button>
</ng-template>

<app-table
    tableKey="specialistRecordList"
    [gridData]="$any(store.works())"
    [transformItem]="workHideDelete()"
    [columns]="columns"
    translatePrefix="workData.specialistRecord."
    [buttons]="extendedWorkExportsEnabled ? buttons : null"
    [hideCheckboxes]="!extendedWorkExportsEnabled"
    [showSearch]="true"
    [showColumnVisiblity]="true"
    [showExport]="true"
    [resource]="'specialistWork'"
    (deleteCallbackWithEvent)="delete($event)"
    (detailCallback)="detail($event)"
    [showDelete]="store.isAllowed('work.delete')() && (!folderId || folderStore.canEdit())"
    [additionalFilter]="additionalFilters"
    [refreshCallback]="store.api.getWorks"
    [defaultSorters]="[{ column: 'dateFrom', direction: 'DESC' }]"
>
    @if (extendedWorkExportsEnabled) {
        <ng-template pTemplate="link" let-item="item">
            <app-button
                styleClass="tableIcon"
                svgIcon="pdf"
                [text]="true"
                (clickEvent)="$event.stopPropagation(); printRecord(item)"
            ></app-button>
        </ng-template>
    } @else if (export()) {
        <ng-template pTemplate="export" let-item="item">
            <app-button
                styleClass="tableIcon"
                svgIcon="pdf"
                [text]="true"
                (clickEvent)="$event.stopPropagation(); printRecord(item)"
            ></app-button>
        </ng-template>
    }
</app-table>
